import ProfileImage from "../../media/profile1.jpg";

function ProfileInfo() {
  return (
    <div className="profile-info-container">
      <div className="profile-info-left-section">
        <p>
          Cuidar de tu salud es mi prioridad. Conmigo a tu lado, recibirás la
          atención médica personalizada que necesitas para recuperar tu vitalidad y mejorar tu calidad de
          vida.<br></br>
          <br></br> Te acompañaré paso a paso hacia una vida más saludable y en equilibrio.
          ¡Agenda tu cita hoy mismo y siente la diferencia desde el primer día!
        </p>
      </div>


      <div className="profile-info-right-section">
        <img src={ProfileImage} alt="gustavo garcia" />
      </div>
    </div>
  );
}

export default ProfileInfo;
